import Vue from 'vue';

Vue.directive('bh-validate', {
    bind: function () {
        // 准备工作
        console.log('binded');
        console.log(this);
    },
    update: function (value) {
        // 值更新时的工作
        console.log('updated');
        console.log(this);
    },
    unbind: function () {
        // 清理工作
        console.log('updated');
    }
});



// WEBPACK FOOTER //
// ./E:/vue/bh-vue-demo/src/directives/bhValidator.js